import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Droplets, Wallet, HelpCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <AlertCircle className="w-8 h-8 text-brand-sage" data-id="element-154" data-mp="30hpr9cm03lf5" />,
    title: 'Acné que no se va',
    description: 'Brotes hormonales constantes y marcas que tardan meses en desaparecer.'
  }, {
    icon: <Droplets className="w-8 h-8 text-brand-sage" data-id="element-155" data-mp="39hma2xlplq2a" />,
    title: 'Piel sensible e irritada',
    description: 'Tratamientos agresivos que han dañado tu barrera cutánea dejándola roja y tirante.'
  }, {
    icon: <Wallet className="w-8 h-8 text-brand-sage" data-id="element-156" data-mp="3jglkolq1bvrx" />,
    title: 'Gastas sin ver resultados',
    description: 'Cajones llenos de productos a medio usar que prometían milagros.'
  }, {
    icon: <HelpCircle className="w-8 h-8 text-brand-sage" data-id="element-157" data-mp="1p1spuowz7911" />,
    title: 'Rutinas confusas',
    description: 'Demasiados pasos y no sabes qué usar, cuándo, ni en qué orden.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-brand-sage-light/10 relative overflow-hidden" data-id="element-158" data-mp="x5ju3ys1mrx3">
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-brand-beige/30 rounded-full blur-3xl -translate-y-1/2 -z-10" data-id="element-159" data-mp="1244ld8pbi19e" />
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-160" data-mp="171mxf7ymswlm">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-161" data-mp="1c229lw76fy20">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-162" data-mp="3dv8l60jrcq62">
            ¿Te identificas? 💭
          </h2>
          <p className="text-brand-charcoal/70" data-id="element-163" data-mp="p00qc5q7sf6i">
            Si has pasado por esto, quiero decirte que no estás sola y que hay
            una forma diferente de cuidar tu piel 🤍
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-164" data-mp="y1762cl1hlyp">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-sm transition-all duration-300 border border-brand-beige/30 soft-glow-hover hover:-translate-y-1" data-id="element-165" data-mp="17xa4p8gon2gw" data-mpi={index}>
              <div className="w-16 h-16 bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-166" data-mp="1cpuy48vofdjw">
                {problem.icon}
              </div>
              <h3 className="text-xl font-serif font-medium text-brand-charcoal mb-3" data-id="element-167" data-mp="1qq5q5f8q2y6n">
                {problem.title}
              </h3>
              <p className="text-brand-charcoal/70 font-light text-sm leading-relaxed" data-id="element-168" data-mp="25cbi8uaya5d9">
                {problem.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}